import { useInfiniteQuery } from '@tanstack/react-query'

import { ApiPaths } from '@/utils/apiPaths'
import { fetchParkingsV2 } from '@/utils/parkingsService'

import { AllParkingsResponseV2 } from '../parkings'

interface AllParkingsPaginationParams {
  query?: string
  lang?: string
  latLon?: string
  radius?: number | ''
  countryCode?: string
  size?: number
  sorting?: string
  subscriptionAvailable?: boolean
  reservationAvailable?: boolean
  infoTags?: string
  search?: string
  visible?: boolean
  category?: string
  keepPreviousData?: boolean
  page: number
}

export const useFetchPaginationParkings = ({
  params
}: {
  params: AllParkingsPaginationParams
}) => {
  const {
    data,
    isLoading,
    isError,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch
  } = useInfiniteQuery<AllParkingsResponseV2, Error>({
    queryKey: [
      ApiPaths.API_V2_PARKINGS,
      'allPages',
      params.search ?? '',
      params
    ],
    queryFn: ({ pageParam = 0 }) =>
      fetchParkingsV2({
        params: {
          ...params,
          page: Number(pageParam) || 0,
          size: params.radius == null ? 150 : params.size || 30
        }
      }),
    getNextPageParam: (lastPage, allPages) => {
      if (params.radius == null) return undefined

      const totalPages = Math.ceil((lastPage.total ?? 0) / (params.size ?? 10))
      const nextPage = allPages.length
      return nextPage < totalPages ? nextPage : undefined
    },
    initialPageParam: 0
  })
  const parkings = data?.pages?.flatMap(page => page.items) || []
  const total = data?.pages?.[0]?.total ?? 0

  return {
    parkings,
    total,
    isLoading,
    isError,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch
  }
}
